import { ShippingDocketTemplate } from "@/components/templates/shipping-docket-1";
import { TicketStandardTemplate } from "@/components/templates/ticket-standard-1";
import { InvoiceStandardTemplate } from "@/components/templates/invoice-standard-1";

export const TemplateRegistry = [
  TicketStandardTemplate,
  ShippingDocketTemplate,
  InvoiceStandardTemplate,
];
